import { Base } from "./model/core/base.model";

export class FlujoAlternoBean extends Base{
    id_principal:number;
	descripcion:string;
    flujo_alterno:number;
    flujo_alterno_anterior:number;
    nombre:string;
}